<template>
	<PopupRouterView :showLeftIcon="true" label="Approval Configuration Instance Input"  entityName="approvalconfigurationinstance" :documentId="mainRecordId"  @saveMethod="saveActionConfirmation" @hideMethod="onHidden">
		<b-card>
			<b-col cols="12" lg="6">
				<app-input-textbox id="fieldset-name" label-cols-sm="4" label-cols-lg="3" label="Name" label-for="input-name" size="sm" :model.sync="model.name"  @change="updateData" />
				<app-input-textbox id="fieldset-approval-instance" label-cols-sm="4" label-cols-lg="3" label="Approval Instance" label-for="input-approval-instance" size="sm" :model.sync="model.approvalInstance"  @change="updateData" />
				<app-input-combobox-autocomplete :options="approvalTypes" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Approval Type" id="input-" size="sm" :model.sync="model.approvalTypeId"  :selected="model.approvalType != null ? model.approvalType.name : ''" @input="getApprovalTypes" @change="updateData"/>
				<app-input-textarea id="fieldset-description" label-cols-sm="4" label-cols-lg="3" label="Description" label-for="input-description" size="sm" :model.sync="model.description"  @change="updateData" />
				<app-input-combobox-autocomplete :options="appliedTos" optionsLabel="name" optionsKey="id" label-cols-sm="4" label-cols-lg="3" label="Applied To" id="input-" size="sm" :model.sync="model.appliedToId"  :selected="model.appliedTo != null ? model.appliedTo.name : ''" @input="getAppliedTos" @change="updateData"/>
			</b-col>
			<b-col>
				<span class="float-right" v-if="modelId != null && modelId != undefined && modelId != ''">
					<b-button variant="success" class="float-right ml-2" @click="downloadData" size="sm"><b-icon-download class="mr-1"></b-icon-download> Download</b-button>
				</span>
			</b-col>
		</b-card>
	<b-card class="mt-3" header-bg-variant="transparent">
		<b-row class="mb-2">
			<b-col cols="9"><h5 class="card-title font-weight-bolder text-dark">Approval Configuration Instance Details</h5></b-col>
			<b-col>
				<span class="float-right">
					<b-form-select v-model="approvalConfigurationInstanceDetailPageSize" size="sm" class="float-right" :options="pagingOptions"></b-form-select>
				</span>
			</b-col>
		</b-row>
		<b-row>
		<b-col>
			<app-table-input-popup :items="approvalConfigurationInstanceDetails" :fields="fieldsApprovalConfigurationInstanceDetail" :busy="isDataLoading" :sort-by.sync="sortByApprovalConfigurationInstanceDetail" :sort-desc.sync="sortDescApprovalConfigurationInstanceDetail" small responsive
			@editButtonMethod="editRowDataApprovalConfigurationInstanceDetail"
			@deleteButtonMethod="deleteRowDataApprovalConfigurationInstanceDetail"
			@showPopupAddMethod="resetDataApprovalConfigurationInstanceDetail()"
			@showPopupUploadMethod="showPopupUploadApprovalConfigurationInstanceDetail()"
			@downloadMethod="downloadApprovalConfigurationInstanceDetail()"
			@addFromClipboardMethod="addFromClipboardApprovalConfigurationInstanceDetail()"
			@replaceFromClipboardMethod="replaceFromClipboardApprovalConfigurationInstanceDetail()"
			:showActionButton="true"
			:showAddButton="true"
			:showAddFromClipboardButton="true"
			:showReplaceFromClipboardButton="true"
			:showUploadButton="true"
			:showDownloadButton="true"
			:isDownloadBusy="isDownloadApprovalConfigurationInstanceDetail"
			>
			<template v-slot:head(actions)>
				<b-button @click="isShowApprovalConfigurationInstanceDetailFilter = !isShowApprovalConfigurationInstanceDetailFilter" class="float-right" size="sm"><b-icon-funnel-fill /></b-button>
			</template>
			<template #top-row v-if="isShowApprovalConfigurationInstanceDetailFilter">
				<b-th></b-th>
				<b-th stacked-heading="Approver Type">
					<v-select append-to-body label="name" :options="approverTypes"  :value="filterApprovalConfigurationInstanceDetail.approverTypeId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverTypeId" @search="getApproverTypes" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approval Structure">
					<v-select append-to-body label="name" :options="approvalStructures"  :value="filterApprovalConfigurationInstanceDetail.approvalStructureId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approvalStructureId" @search="getApprovalStructures" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Approver Level">
					<b-form-input id="input-approver-level-table" v-model="filterApprovalConfigurationInstanceDetail.approverLevel" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approver User Name">
					<v-select append-to-body label="firstName" :options="userInfos"  :value="filterApprovalConfigurationInstanceDetail.approverUserNameId" :reduce="item => item.id" v-model="filterApprovalConfigurationInstanceDetail.approverUserNameId" @search="getUserInfos" :filterable="true"></v-select>
				</b-th>
				<b-th stacked-heading="Stored Procedure Name">
					<b-form-input id="input-stored-procedure-name-table" v-model="filterApprovalConfigurationInstanceDetail.storedProcedureName" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Approval Type">
					<b-form-input id="input-approval-type-table" v-model="filterApprovalConfigurationInstanceDetail.approvalType" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Configuration Content">
					<b-form-input id="input-configuration-content-table" v-model="filterApprovalConfigurationInstanceDetail.configurationContent" size="sm"></b-form-input>
				</b-th>
				<b-th stacked-heading="Is Send Notification">
					<b-form-checkbox id="input-is-send-notification-table" class="float-right" v-model="filterApprovalConfigurationInstanceDetail.isSendNotification"></b-form-checkbox>
				</b-th>
				<b-th>
				</b-th>
			</template>
			<template v-slot:cell(no)="row">
				{{ ((row.index + 1) + ( approvalConfigurationInstanceDetailPageSize * (currentApprovalConfigurationInstanceDetailPage - 1))) }}
			</template>
			<template v-slot:table-busys>
				<div class="text-center my-2">
			<b-spinner class="align-middle text-primary"></b-spinner>
				<strong class="ml-2">Loading...</strong>
				</div>
			</template>
			<template v-slot:cell(approvalConfigurationInstance)="row">
				{{ row.item.approvalConfigurationInstance != null ? row.item.approvalConfigurationInstance.name : "" }}
			</template>
			<template v-slot:cell(approverType)="row">
				{{ row.item.approverType != null ? row.item.approverType.name : "" }}
			</template>
			<template v-slot:cell(approvalStructure)="row">
				{{ row.item.approvalStructure != null ? row.item.approvalStructure.name : "" }}
			</template>
			<template v-slot:cell(approverUserName)="row">
				{{ row.item.approverUserName != null ? row.item.approverUserName.firstName : "" }}
			</template>
				<template v-slot:form-add-detail>
				<ApprovalConfigurationInstanceDetailInput 
					:openPopup="isShowPopupApprovalConfigurationInstanceDetail"
					:modelId="approvalConfigurationInstanceDetailId"
					@resetMethod="resetModal"
					@addButtonMethod="addRowDataApprovalConfigurationInstanceDetail"/>
				</template>
				<template v-slot:upload-detail>
					<ApprovalConfigurationInstanceDetailUpload
					:openPopup="isShowPopupUploadApprovalConfigurationInstanceDetail"
					@resetMethod="resetModal"
					@uploadButtonMethod="uploadDataApprovalConfigurationInstanceDetail"
					:parentId="modelId"
				 />
				</template>
			<template v-slot:table-paging>
				<b-pagination
				class="float-right btn-paging"
				v-model="currentApprovalConfigurationInstanceDetailPage"
				:total-rows="totalApprovalConfigurationInstanceDetailRow"
				:per-page="approvalConfigurationInstanceDetailPageSize"
				aria-controls="my-table"
				></b-pagination>
			</template>
			</app-table-input-popup>
		</b-col>
		</b-row>
	</b-card>
		<PopupConfirmationDetail :openPopup="isShowPopupConfirmation" :modelId="modelId" @saveActionMethod="saveAction" @resetMethod="resetModal" />
		<b-overlay :show="isBusy" no-wrap></b-overlay>
	</PopupRouterView>
</template>
<script>
import axios from 'axios';
import { validationMixin } from "vuelidate";
import { required, minLength } from "vuelidate/lib/validators";
import ApprovalConfigurationInstance from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstance';
import ApprovalConfigurationInstanceList from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceList';
import ApprovalConfigurationInstanceFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceFilter';

import PopupConfirmationDetail from './PopupConfirmationDetail';

import AppInputTextbox from '@/components/AppInputTextbox';
import AppInputComboboxAutocomplete from '@/components/AppInputComboboxAutocomplete';
import ApprovalType from '@/models/ApprovalType/ApprovalType';
import ApprovalTypeFilter from '@/filters/ApprovalType/ApprovalTypeFilter';
import AppInputTextarea from '@/components/AppInputTextarea';
import AppliedTo from '@/models/AppliedTo/AppliedTo';
import AppliedToFilter from '@/filters/AppliedTo/AppliedToFilter';
import ApprovalConfigurationInstanceDetail from '@/models/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetail';
import ApprovalConfigurationInstanceDetailFilter from '@/filters/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailFilter';
import ApproverType from '@/models/ApproverType/ApproverType';
import ApproverTypeFilter from '@/filters/ApproverType/ApproverTypeFilter';
import ApprovalStructure from '@/models/ApprovalStructure/ApprovalStructure';
import ApprovalStructureFilter from '@/filters/ApprovalStructure/ApprovalStructureFilter';
// import UserInfo from '@/models/PrivilegeManagement/UserInfo';
// import UserInfoFilter from '@/filters/PrivilegeManagement/UserInfoFilter';
import AppTableInput from '@/components/AppTableInput';
import AppTableInputPopup from '@/components/AppTableInputPopup';
import ApprovalConfigurationInstanceDetailInput from '@/views/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailInput';
import ApprovalConfigurationInstanceDetailUpload from '@/views/ApprovalConfigurationInstance/ApprovalConfigurationInstanceDetailUpload';
import PopupRouterView from '@/components/PopupRouterView';
export default {
	components : {AppInputTextbox,AppInputComboboxAutocomplete,AppInputTextarea,ApprovalConfigurationInstanceDetailInput,ApprovalConfigurationInstanceDetailUpload,AppTableInput,AppTableInputPopup,PopupRouterView,PopupConfirmationDetail},
	mixins : [validationMixin],
	validations: {
		model: {
		}
	},
	data() {
		return {
			errorMessage : {
			},
			datas: Array(),
			selectAll:false,
			sortBy: '',
			sortDesc: '',
			pagingOptions:[
				{ value : '10', text : '10', selected:true },
				{ value : '25', text : '25' },
				{ value : '50', text : '50' },
				{ value : '100', text : '100' },
			],
			fieldsApprovalConfigurationInstanceDetail: [
				{"no" : { "class" : "th-number"}}, 
				{"approverType": { "class" : "th-approver-type"}, "label" : "Approver Type", key: 'approverType', sortable: true}, 
				{"approvalStructure": { "class" : "th-approval-structure"}, "label" : "Approval Structure", key: 'approvalStructure', sortable: true}, 
				{"approverLevel": { "class" : "th-approver-level"}, "label" : "Approver Level", key: 'approverLevel', sortable: true}, 
				{"approverUserName": { "class" : "th-approver-user-name"}, "label" : "Approver User Name", key: 'approverUserName', sortable: true}, 
				{"storedProcedureName": { "class" : "th-stored-procedure-name"}, "label" : "Stored Procedure Name", key: 'storedProcedureName', sortable: true}, 
				{"approvalType": { "class" : "th-approval-type"}, "label" : "Approval Type", key: 'approvalType', sortable: true}, 
				{"configurationContent": { "class" : "th-configuration-content"}, "label" : "Configuration Content", key: 'configurationContent', sortable: true}, 
				{"isSendNotification": { "class" : "th-is-send-notification"}, "label" : "Is Send Notification", key: 'isSendNotification', sortable: true}, 
				{"actions": { "class" : "th-actions", "label" : ""}}
			],
			busy:false,
			isBusy: false,
			isDataLoading: false,
			selected:'',
			pageSizeOptions: 10,
			pageIndex:0,
			sortingBy: Array(),
			modelId: null,
			model: {},
			modelApprovalConfigurationInstanceDetail : {},
			isShowPopupApprovalConfigurationInstanceDetail : false,
			isShowPopupUploadApprovalConfigurationInstanceDetail : false,
			filterApprovalConfigurationInstance : null,
			currentApprovalConfigurationInstancePage : 1,
			approvalConfigurationInstancePageSize: 10,
			sortByApprovalConfigurationInstance: '',
			sortDescApprovalConfigurationInstance: '',
			filterApprovalConfigurationInstanceDetail : null,
			currentApprovalConfigurationInstanceDetailPage : 1,
			approvalConfigurationInstanceDetailPageSize: 10,
			sortByApprovalConfigurationInstanceDetail: '',
			sortDescApprovalConfigurationInstanceDetail: '',
			sortingByApprovalConfigurationInstanceDetail: [],
			approvalConfigurationInstanceDetails : [],
			approvalConfigurationInstanceDetailId : '',
			totalApprovalConfigurationInstanceDetailRow : 0,
			isShowApprovalConfigurationInstanceDetailFilter: false,
			isDownloadApprovalConfigurationInstanceDetail: false,
			approverTypes: [],
			approvalStructures: [],
			userInfos: [],
			approvalTypes: [],
			appliedTos: [],
			isShowPopupConfirmation : false,
			isDataCommited : false,
			mainRecordId : '',
		}
	},
	methods : {
		getApprovalConfigurationInstance : async function(id) {
			this.isBusy = true;
			ApprovalConfigurationInstance.getData(this, id).then(result => { this.model = result; this.mainRecordId = String(result.mainRecordId); this.isBusy = false; }).catch(error => { this.isBusy = false; });
		},
		downloadData() {
			this.isDownloadApprovalConfigurationInstance = true;
			this.filterApprovalConfigurationInstance.id = this.modelId;
			ApprovalConfigurationInstance.downloadDataDetail(this, this.filterApprovalConfigurationInstance).then(result => {
				this.isDownloadApprovalConfigurationInstance = false;
			}).catch(error => { this.isDownloadApprovalConfigurationInstance = false; })
		},
		getApprovalConfigurationInstanceDetails : async function(isAddRow) {
			let filter = {};
			Object.assign(filter, this.filterApprovalConfigurationInstanceDetail);
			if (this.modelId == null) return;
			filter.approvalConfigurationInstanceId = this.modelId;
			filter.draftMode = "1";
			if (this.sortByApprovalConfigurationInstanceDetail != null) {
				this.sortingByApprovalConfigurationInstanceDetail[this.sortByApprovalConfigurationInstanceDetail] = this.sortDescApprovalConfigurationInstanceDetail;
			}
			let currentPage = (this.currentApprovalConfigurationInstanceDetailPage - 1);
			if (isAddRow) {
				let totalData = this.totalApprovalConfigurationInstanceDetailRow + 1;
				let page = Math.ceil(totalData/this.approvalConfigurationInstanceDetailPageSize);
				currentPage = page - 1;
			}
			ApprovalConfigurationInstanceDetail.getList(this, filter, this.sortingByApprovalConfigurationInstanceDetail, currentPage , this.approvalConfigurationInstanceDetailPageSize).then(result => {
				this.currentApprovalConfigurationInstanceDetailPage = currentPage + 1;
				this.approvalConfigurationInstanceDetails = result.data;
				this.totalApprovalConfigurationInstanceDetailRow = result.dataCount;
			}).catch(error => {});
		},
		getApprovalConfigurationInstances : async function(input) {
			let filter = new ApprovalConfigurationInstanceFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalConfigurationInstance.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalConfigurationInstances = result.data
				}
			})
			.catch(error => {});
		},
		getApproverTypes : async function(input) {
			let filter = new ApproverTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApproverType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approverTypes = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalStructures : async function(input) {
			let filter = new ApprovalStructureFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalStructure.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalStructures = result.data
				}
			})
			.catch(error => {});
		},
		getUserInfos : async function(input) {
			let filter = new UserInfoFilter();
			if (input != undefined) {
				filter.firstName = input;
			}
			UserInfo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.userInfos = result.data
				}
			})
			.catch(error => {});
		},
		getApprovalTypes : async function(input) {
			let filter = new ApprovalTypeFilter();
			if (input != undefined) {
				filter.name = input;
			}
			ApprovalType.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.approvalTypes = result.data
				}
			})
			.catch(error => {});
		},
		getAppliedTos : async function(input) {
			let filter = new AppliedToFilter();
			if (input != undefined) {
				filter.name = input;
			}
			AppliedTo.getList(this, filter, null, 0, 10)
			.then(result => {
				if (result != null) {
					this.appliedTos = result.data
				}
			})
			.catch(error => {});
		},
		validateState(name) {
			if (!this.$v.model[name]) return null;
			const { $dirty, $error } = this.$v.model[name];
			return $dirty ? !$error : null;
		},
		getErrorMessage(message, name) {
			if (!this.$v.model[name]) return "";
			if (this.$v.model[name].required != undefined && !this.$v.model[name].required) {
				if (message.required) return message.required;
			}
		},
		saveActionConfirmation(modalEvent) {
			modalEvent.preventDefault();
			let id = this.$route.params.id;
			this.$v.model.$touch(); 
			if (this.$v.model.$anyError) {
				return;
			} else {
				this.isShowPopupConfirmation = true;
			}
		},
		saveAction(modalEvent) {
			this.isBusy = true;
			let id = this.modelId;
			let model = this.model;

			if (id != '' && id != null && id != undefined) {
				ApprovalConfigurationInstance.commitData(this, model, id).then(result => {
					this.isDataCommited = true;
					this.$router.push({ name: 'approvalconfigurationinstanceindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			} else {
				ApprovalConfigurationInstance.insertData(this, model).then(result => {
					this.$router.push({ name: 'approvalconfigurationinstanceindex' });
					this.isBusy = false;
				}).catch(error => { this.isBusy = false; });
			}
		},
		updateData() {
			let id = this.modelId;
			let model = this.model;

			let promises = Array();

			Promise.all(promises).then((results) => {
				if (id != '' && id != null && id != undefined) {
					ApprovalConfigurationInstance.updateData(this, model, id);
				}
			});
		},
		onHidden() {
			this.getApprovalConfigurationInstances();
		},
		addRowDataApprovalConfigurationInstanceDetail(modalEvent, model) {
			if (model != null) {
				if (model.id != null && model.id != '') {
					model.approvalConfigurationInstanceId =  this.modelId;
					ApprovalConfigurationInstanceDetail.updateDataDetail(this, model, model.id)
					.then(result => {
						this.getApprovalConfigurationInstanceDetails(true);
						this.isShowPopupApprovalConfigurationInstanceDetail = false;
					})
				} else {
					model.approvalConfigurationInstanceId =  this.modelId;
					ApprovalConfigurationInstanceDetail.createDataDetail(this, model)
					.then(result => {
						this.getApprovalConfigurationInstanceDetails(true);
						this.isShowPopupApprovalConfigurationInstanceDetail = false;
					})
				}
			}
		},
		async editRowDataApprovalConfigurationInstanceDetail(id) {
			this.approvalConfigurationInstanceDetailId = id;
			this.isShowPopupApprovalConfigurationInstanceDetail = true; 
		},
		async deleteRowDataApprovalConfigurationInstanceDetail(id) {
			ApprovalConfigurationInstanceDetail.deleteData(this, id).then(result => { this.getApprovalConfigurationInstanceDetails(); });
		},
		async resetDataApprovalConfigurationInstanceDetail() {
			this.approvalConfigurationInstanceDetailId = "";
			this.isShowPopupApprovalConfigurationInstanceDetail = true;
		},
		async addDataApprovalConfigurationInstanceDetail() {
			ApprovalConfigurationInstanceDetail.createDataDetail(this, { approvalConfigurationInstanceId: this.modelId })
			.then(result => {
				this.getApprovalConfigurationInstanceDetails(true);
			})
		},
		async addFromClipboardApprovalConfigurationInstanceDetail() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalConfigurationInstanceId: this.modelId });
				});
				ApprovalConfigurationInstanceDetail.addFromClipboard(this, approverTypes).then(result => { this.getApprovalConfigurationInstanceDetails() });
			});
		},
		async replaceFromClipboardApprovalConfigurationInstanceDetail() {
			let approverTypes = new Array();
			navigator.clipboard.readText().then(value => {
				if(value.match(/(?:\r\n|\r|\n)/g)) { value=value.replace(/(?:\r\n|\r|\n)/g, ',') ; }
				let values = value.split(",");
				values.forEach(item => {
					approverTypes.push({ approverType: item, approvalConfigurationInstanceId: this.modelId });
				});
				ApprovalConfigurationInstanceDetail.replaceFromClipboard(this, approverTypes).then(result => { this.getApprovalConfigurationInstanceDetails() });
			});   
		},
		showPopupUploadApprovalConfigurationInstanceDetail() {
			this.isShowPopupUploadApprovalConfigurationInstanceDetail = true;
		},
		uploadDataApprovalConfigurationInstanceDetail(modalEvent, newDatas) {
			this.isShowPopupUploadApprovalConfigurationInstanceDetail = false; 
		},
		downloadApprovalConfigurationInstanceDetail(modalEvent) {
			this.isDownloadApprovalConfigurationInstanceDetail = true;
			this.filterApprovalConfigurationInstanceDetail.approvalConfigurationInstanceId = this.modelId;
			ApprovalConfigurationInstanceDetail.downloadDataDetail(this, this.filterApprovalConfigurationInstanceDetail).then(result => {
				this.isDownloadApprovalConfigurationInstanceDetail = false;
			}).catch(error => { this.isDownloadApprovalConfigurationInstanceDetail = false; })
		},
		saveInputApprovalConfigurationInstanceDetail(item) {
			ApprovalConfigurationInstanceDetail.updateDataDetail(this, item, item.id);
		},
		resetModal(modalType) {
			this.isShowPopupUploadApprovalConfigurationInstanceDetail = false; 
			this.isShowPopupApprovalConfigurationInstanceDetail = false; 
			if (modalType == 'ApprovalConfigurationInstanceDetail') {
				this.getApprovalConfigurationInstanceDetails();
			}
			this.showPopupCopyData = false; 
			this.isShowPopupConfirmation = false;
		},
		displayFilter() {
			this.windowWidth = window.innerWidth;
			if (this.windowWidth <= 768 ) {
				this.isShowApprovalConfigurationInstanceDetailFilter = true;
			}
		},
	},
	beforeMount() {
		this.filterApprovalConfigurationInstance = new ApprovalConfigurationInstanceFilter();
		this.filterApprovalConfigurationInstanceDetail = new ApprovalConfigurationInstanceDetailFilter();
		this.getApprovalConfigurationInstances();
		this.getApproverTypes();
		this.getApprovalStructures();
		this.getUserInfos();
		this.getApprovalTypes();
		this.getAppliedTos();
	},
	async mounted(){
		let id = this.$route.params.id;
		let copyData = this.$route.params.copydata;
		if (id != '' && id != null && id != undefined) {
			if (copyData != null && copyData != undefined) {
				this.getApprovalConfigurationInstance(id);
			} else {
				this.modelId = id;
				this.getApprovalConfigurationInstance(id);
			}
		}
		this.$nextTick(() => {
			window.addEventListener('resize', this.displayFilter);
			this.displayFilter();
		});
	},
	computed: {
	},
	watch : {
		sortByApprovalConfigurationInstanceDetail : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		sortDescApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		currentApprovalConfigurationInstanceDetailPage: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		approvalConfigurationInstanceDetailPageSize : {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			}
		},
		filterApprovalConfigurationInstanceDetail: {
			handler: function() {
				this.getApprovalConfigurationInstanceDetails();
			},
			deep: true,
		},
	},
	beforeDestroy() {
		if (!this.isDataCommited) {
			ApprovalConfigurationInstance.discardData(this, this.modelId);
		}
	},
}
</script>
